import React from 'react';
import { getStatusConfig, PIPELINE_STAGES, getStatusIndex } from '../lib/statusUtils';
import { Check, AlertCircle } from 'lucide-react';

const DISPLAY_STAGES = [
  { key: 'draft', label: 'Draft' },
  { key: 'script_ready', label: 'Script' },
  { key: 'completed', label: 'Video' },
];

export const StatusPipeline = ({ status }) => {
  const isFailed = status === 'failed';
  const currentIdx = getStatusIndex(status);

  const getStageState = (stageKey) => {
    const stageIdx = PIPELINE_STAGES.indexOf(stageKey);
    if (isFailed) return 'failed';
    if (currentIdx > stageIdx) return 'completed';
    if (currentIdx === stageIdx) return 'active';
    if (stageKey === 'script_ready' && (status === 'script_generating')) return 'active';
    if (stageKey === 'completed' && (status === 'video_rendering')) return 'active';
    return 'pending';
  };

  return (
    <div className="flex items-center gap-1" data-testid="status-pipeline">
      {DISPLAY_STAGES.map((stage, idx) => {
        const state = getStageState(stage.key);
        return (
          <React.Fragment key={stage.key}>
            <div className="flex items-center gap-1.5" data-testid={`status-pipeline-stage-${stage.key}`}>
              <div className={`w-5 h-5 rounded-full flex items-center justify-center text-[10px] font-medium
                ${state === 'completed' ? 'bg-teal-600 text-white' : ''}
                ${state === 'active' ? 'bg-[hsl(38,78%,56%)] text-white animate-pulse-dot' : ''}
                ${state === 'pending' ? 'bg-muted text-muted-foreground' : ''}
                ${state === 'failed' ? 'bg-red-500 text-white' : ''}
              `}>
                {state === 'completed' ? <Check className="w-3 h-3" /> : 
                 state === 'failed' ? <AlertCircle className="w-3 h-3" /> :
                 idx + 1}
              </div>
              <span className={`text-xs font-medium hidden sm:inline
                ${state === 'completed' ? 'text-teal-700' : ''}
                ${state === 'active' ? 'text-[hsl(38,78%,45%)]' : ''}
                ${state === 'pending' ? 'text-muted-foreground' : ''}
                ${state === 'failed' ? 'text-red-600' : ''}
              `}>
                {stage.label}
              </span>
            </div>
            {idx < DISPLAY_STAGES.length - 1 && (
              <div className={`h-[2px] w-6 sm:w-10 rounded-full
                ${state === 'completed' ? 'bg-teal-300' : 'bg-muted'}
              `} />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};
